document.addEventListener('DOMContentLoaded', () => {
  const configurator = document.querySelector('.lumihome-configurator');
  if (!configurator) return;

  const state = { step: 1, maxSteps: 7, answers: {} };
  let currentSchemaUrls = [];
  let currentBundleItems = [];

  const steps = Array.from(document.querySelectorAll('.lc-step'));
  const btnNext = document.getElementById('lc-btn-next');
  const btnPrev = document.getElementById('lc-btn-prev');
  const btnReset = document.getElementById('lc-btn-reset');
  const progressBar = document.getElementById('lc-progress-bar');

  const bulbPowerContainer = document.getElementById('lc-bulb-power-container');
  const bulbPowerInput = document.getElementById('bulb_power');
  const step3Warning = document.getElementById('lc-blocking-warning-step3');
  const spotsCountInput = document.getElementById('spots_count');
  const infoSpotsAmpoule = document.getElementById('lc-info-spots-ampoule');

  const btnDownloadSchema = document.getElementById('lc-btn-download-schema');
  const btnAddAll = document.getElementById('lc-btn-add-all');
  const bundleContainer = document.getElementById('lc-bundle-container');
  const bundleList = document.getElementById('lc-bundle-list');
  const bundleTotalEl = document.getElementById('lc-bundle-total-price');
  const bundleNote = document.getElementById('lc-bundle-note');

  const schemasDataEl = document.getElementById('lc-schemas-data');
  const schemasImages = schemasDataEl ? safeParseJSON(schemasDataEl.textContent, {}) : {};

  const productsDataEl = document.getElementById('lc-products-data');
  const productsArray = productsDataEl ? safeParseJSON(productsDataEl.textContent, []) : [];
  const productsMap = productsArray.reduce((acc, p) => {
    if (p && p.key) acc[p.key] = p;
    return acc;
  }, {});

  const moneyFormat = configurator.getAttribute('data-money-format') || '€{{amount}}';

  btnNext.addEventListener('click', handleNext);
  btnPrev.addEventListener('click', handlePrev);
  btnReset.addEventListener('click', resetConfigurator);
  if (btnDownloadSchema) btnDownloadSchema.addEventListener('click', handleDownloadSchema);
  if (btnAddAll) btnAddAll.addEventListener('click', handleAddAllToCart);

  if (bundleList) {
    bundleList.addEventListener('change', function(e) {
      const select = e.target.closest('.lc-bundle-item-swap');
      if (!select) return;
      const itemIndex = parseInt(select.dataset.itemIndex, 10);
      const newKey = select.value;
      const item = currentBundleItems[itemIndex];
      if (!item || !item.options) return;
      const opt = item.options.find(o => o.key === newKey);
      if (opt && opt.product) {
        item.key = opt.key;
        item.product = opt.product;
        renderBundle(currentBundleItems);
      }
    });
  }

  spotsCountInput.addEventListener('input', updateStep4InfoTexts);
  document.querySelectorAll('input[name="spot_type"]').forEach(radio => {
    radio.addEventListener('change', () => { evaluateStep3Blocking(); });
  });

  function updateView() {
    steps.forEach(s => s.classList.remove('active'));
    const currentStepEl = document.querySelector(`.lc-step[data-step="${state.step}"]`);
    if (currentStepEl) currentStepEl.classList.add('active');

    progressBar.style.width = `${(state.step / state.maxSteps) * 100}%`;

    btnPrev.classList.toggle('lc-hidden', state.step === 1 || state.step === state.maxSteps);
    btnNext.classList.toggle('lc-hidden', state.step === state.maxSteps);
    btnReset.classList.toggle('lc-hidden', state.step !== state.maxSteps);

    if (state.step === 3) evaluateStep3Blocking();
    else btnNext.disabled = false;

    if (state.step === 4) updateStep4InfoTexts();
    if (state.step === state.maxSteps) generateResult();
  }

  function evaluateStep3Blocking() {
    const selectedInstall = document.querySelector('input[name="install_type"]:checked')?.value;
    const selectedSpot = document.querySelector('input[name="spot_type"]:checked')?.value;

    if (selectedSpot === 'ampoule') bulbPowerContainer.classList.remove('lc-hidden');
    else bulbPowerContainer.classList.add('lc-hidden');

    if (selectedInstall === '100_lumihome' && selectedSpot === 'ampoule') {
      step3Warning.classList.remove('lc-hidden');
      btnNext.disabled = true;
    } else {
      step3Warning.classList.add('lc-hidden');
      btnNext.disabled = false;
    }
  }

  function updateStep4InfoTexts() {
    const selectedSpot = document.querySelector('input[name="spot_type"]:checked')?.value;
    if (infoSpotsAmpoule) {
      infoSpotsAmpoule.classList.toggle('lc-hidden', selectedSpot !== 'ampoule');
    }
  }

  function handleNext() {
    if (!validateCurrentStep()) return;
    saveCurrentStepData();
    if (state.step < state.maxSteps) state.step++;
    updateView();
  }

  function handlePrev() {
    if (state.step > 1) state.step--;
    updateView();
  }

  function resetConfigurator() {
    state.step = 1;
    state.answers = {};
    document.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);
    spotsCountInput.value = 4;
    bulbPowerInput.value = '';
    bulbPowerContainer.classList.add('lc-hidden');
    step3Warning.classList.add('lc-hidden');
    currentSchemaUrls = [];
    currentBundleItems = [];
    if (btnDownloadSchema) btnDownloadSchema.disabled = true;
    if (bundleContainer) bundleContainer.hidden = true;
    updateView();
  }

  function validateCurrentStep() {
    const currentStepEl = document.querySelector(`.lc-step[data-step="${state.step}"]`);
    const radios = currentStepEl.querySelectorAll('input[type="radio"]');

    if (radios.length > 0 && !Array.from(radios).some(r => r.checked)) {
      alert("Veuillez sélectionner une option pour continuer.");
      return false;
    }
    if (state.step === 3 && document.querySelector('input[name="spot_type"]:checked')?.value === 'ampoule') {
      if (!bulbPowerInput.value || parseFloat(bulbPowerInput.value) <= 0) {
        alert("Veuillez indiquer la puissance de l'ampoule en Watts.");
        return false;
      }
    }
    if (state.step === 4) {
      if (!spotsCountInput.value || parseInt(spotsCountInput.value, 10) <= 0) {
        alert("Veuillez indiquer un nombre de spots valide.");
        return false;
      }
    }
    return true;
  }

  function saveCurrentStepData() {
    const currentStepEl = document.querySelector(`.lc-step[data-step="${state.step}"]`);
    const inputs = currentStepEl.querySelectorAll('input');
    inputs.forEach(input => {
      if (input.type === 'radio' && input.checked) state.answers[input.name] = input.value;
      else if (input.type === 'number') state.answers[input.name] = input.value;
    });
  }

  function renderSchema(key, container, title = '') {
    if (title) container.innerHTML += `<h4 style="margin-top:20px; color:var(--lh-primary-dark); font-size: 1rem;">${title}</h4>`;
    if (schemasImages[key]) {
      container.innerHTML += `<img src="${schemasImages[key]}" alt="Schéma de câblage" style="margin-bottom: 20px; width:100%; border-radius:8px;">`;
      currentSchemaUrls.push({ url: schemasImages[key], title: title || 'schema' });
    } else {
      container.innerHTML += `
        <div style="padding:20px; background:#f9f9f9; border-radius:8px; text-align:center; border: 2px dashed #ddd; margin-bottom: 20px;">
          <p style="margin:0; font-weight:bold; color:#666;">Schéma indicatif</p>
          <p style="margin:5px 0 0 0; font-size:0.85em; color:#999;">Référence : <code>${key}</code></p>
        </div>
      `;
    }
  }

  function connectorsForSouple(spots, lines) {
    return { connectors: Math.max(0, spots - 1), tubes: lines };
  }

  function calculateOptimalPowerSetup(totalPower) {
    if (totalPower <= 24) {
      return { t24: 1, t96: 0, text: "1x Transformateur Lumihome 24W" };
    }
    if (totalPower <= 48) {
      return { t24: 0, t96: 1, text: "1x Transformateur Lumihome 96W <em>(ou 2x Transformateurs 24W)</em>" };
    }
    if (totalPower <= 96) {
      return { t24: 0, t96: 1, text: "1x Transformateur Lumihome 96W" };
    }
    // Dépassement > 96W
    const count96 = Math.floor(totalPower / 96);
    const remainder = totalPower % 96;
    let count24 = 0;

    if (remainder > 0) {
      if (remainder <= 24) count24 = 1;
      else count24 = 0; // On passe à un 96W supplémentaire
    }
    const final96 = remainder > 24 ? count96 + 1 : count96;

    let textDesc = '';
    if (count24 > 0) {
      textDesc = `${final96}x Transformateur(s) Lumihome 96W + ${count24}x Transformateur 24W`;
    } else {
      textDesc = `${final96}x Transformateurs Lumihome 96W`;
    }

    return { t24: count24, t96: final96, text: textDesc };
  }

  function generateResult() {
    const { install_type, terrace_type, spot_type, bulb_power, spots_count, lines_count, distance } = state.answers;

    const errContainer = document.getElementById('lc-error-state');
    const successContainer = document.getElementById('lc-success-state');
    errContainer.classList.add('lc-hidden');
    successContainer.classList.add('lc-hidden');

    if (install_type === '100_lumihome' && terrace_type === 'beton') {
      showError("Incompatibilité : L'installation avec rallonges Lumihome n'est pas adaptée pour une chape en béton sans réservation suffisante. Avec le système Plug&Play et les rallonges de 2,5 mètres, les connexions nécessitent un espace d'accès sous terrasse bois ou composite.");
      hideBundle();
      return;
    }
    if (install_type === '100_lumihome' && spot_type === 'ampoule') {
      showError("Incompatibilité : Les spots à ampoule interchangeable ne sont pas compatibles avec le système de rallonges Plug&Play Lumihome.");
      hideBundle();
      return;
    }

    const spotsNum = parseInt(spots_count, 10);
    const powerPerSpot = spot_type === 'led_integree' ? 4.5 : parseFloat(bulb_power);
    const totalPower = parseFloat((spotsNum * powerPerSpot).toFixed(1));
    const linesNum = lines_count === '2_lignes' ? 2 : 1;
    const powerSetup = calculateOptimalPowerSetup(totalPower);

    let spotCategoryKey = '';
    if (spot_type === 'ampoule' && install_type !== '100_lumihome') spotCategoryKey = 'ampoules';
    else spotCategoryKey = spotsNum <= 5 ? '1_5_spots' : 'plus_5_spots';
    const baseSchemaKey = `schema_${install_type}_${lines_count}_${spotCategoryKey}`;

    const outReco = document.getElementById('lc-out-recommendation');
    const outMat = document.getElementById('lc-out-material');
    const outWarn = document.getElementById('lc-out-warnings');
    outReco.innerHTML = ''; outMat.innerHTML = ''; outWarn.innerHTML = '';

    /* ---- RECOMMANDATIONS ---- */
    if (install_type === '100_lumihome') {
      outReco.innerHTML += `<li><strong>Installation Lumihome :</strong> Système modulaire sécurisé 12V avec câble souple Plug&Play.</li>`;
    } else if (install_type === 'cable_souple') {
      outReco.innerHTML += `<li><strong>Adaptation sur câble souple existant :</strong> Câble conseillé 1,5mm² H07RNF (passer à 2,5mm² ou 4mm² si la ligne dépasse 15m pour éviter les chutes de tension).</li>`;
    } else {
      outReco.innerHTML += `<li><strong>Adaptation sur câble rigide :</strong> Raccordement possible uniquement à l'aide de boîtes étanches coulées à la résine.</li>`;
    }

    outReco.innerHTML += `<li><strong>Puissance totale consommée :</strong> ${totalPower}W (${spotsNum} spots × ${powerPerSpot}W).</li>`;

    if (totalPower <= 24) {
      outReco.innerHTML += `<li><strong>Alimentation :</strong> Le transformateur Lumihome 24W est parfaitement dimensionné.</li>`;
    } else if (totalPower <= 48) {
      if (linesNum === 2) {
        outReco.innerHTML += `<li><strong>Alimentation :</strong> Vous pouvez utiliser <strong>1x Transformateur 96W central</strong> pour alimenter vos 2 lignes, ou bien <strong>2x Transformateurs 24W</strong> indépendants (1 par ligne).</li>`;
      } else {
        outReco.innerHTML += `<li><strong>Alimentation :</strong> Le transformateur Lumihome 96W couvre parfaitement votre besoin avec une réserve de puissance confortable.</li>`;
      }
    } else if (totalPower <= 96) {
      if (linesNum === 2) {
        outReco.innerHTML += `<li><strong>Alimentation :</strong> 1x Transformateur Lumihome 96W avec dérivation centrale vers vos 2 lignes.</li>`;
      } else {
        outReco.innerHTML += `<li><strong>Alimentation :</strong> 1x Transformateur Lumihome 96W adapté pour votre ligne unique.</li>`;
      }
    } else {
      outReco.innerHTML += `<li><strong>Alimentation haute puissance (${totalPower}W) :</strong> Configuration préconisée : <strong>${powerSetup.text}</strong>.</li>`;
    }

    /* ---- MATÉRIEL ---- */
    outMat.innerHTML += `<li>${spotsNum}x Spot(s) ${spot_type === 'led_integree' ? 'LED Intégrée (4,5W)' : 'à ampoule interchangeable (sans ampoule)'}</li>`;

    if (spot_type === 'ampoule') {
      outMat.innerHTML += `<li>${spotsNum}x Ampoule(s) de ${bulb_power}W (culot compatible)</li>`;
    }

    // Transformateur
    outMat.innerHTML += `<li>${powerSetup.text}</li>`;

    if (install_type === '100_lumihome') {
      let rallongesCount = spotsNum;
      rallongesCount += 1;
      outMat.innerHTML += `<li>${rallongesCount}x Rallonge(s) 2,5M & connecteurs étanches (T de connexion inclus).</li>`;
    } else if (install_type === 'cable_souple') {
      const { connectors: connectorsCount, tubes: tubesCount } = connectorsForSouple(spotsNum, linesNum);
      const derivationNote = linesNum === 2 ? ' <em>(dont 1 pour la dérivation principale)</em>' : '';
      outMat.innerHTML += `<li>${connectorsCount}x Connecteur(s) rapide(s) RAC/T116 <em>ou</em> Boîte(s) étanche(s) RAC-BOX3-68${derivationNote}.</li>`;
      outMat.innerHTML += `<li>${tubesCount}x Connecteur(s) étanche de fin de ligne (RAC/TUBE).</li>`;

      if (spot_type === 'led_integree') {
        outMat.innerHTML += `<li><strong>Note technique de raccordement :</strong> Coupez simplement le connecteur Plug&Play d'origine du spot pour raccorder ses fils à votre connecteur étanche. <strong>La garantie constructeur Lumihome reste 100% préservée.</strong></li>`;
      }
    } else if (install_type === 'cable_rigide') {
      const boitiersCount = spotsNum + 1;
      outMat.innerHTML += `<li>${boitiersCount}x Boîtes étanches RAC-BOX3-68 (1 par spot + 1 au départ du transformateur).</li>`;
      outMat.innerHTML += `<li>${boitiersCount}x Sachets de résine d'étanchéité (à couler impérativement après validation des branchements).</li>`;
    }

    /* ---- AVERTISSEMENTS ---- */
    outWarn.innerHTML += `<li>Coupez impérativement l'alimentation générale au disjoncteur avant toute intervention.</li>`;
    if (terrace_type === 'beton') {
      outWarn.innerHTML += `<li><strong>Terrasse béton :</strong> Les câbles doivent obligatoirement être passés sous gaine ICTA noyée dans la dalle.</li>`;
    }
    if (install_type === 'cable_rigide') {
      outWarn.innerHTML += `<li>Les connecteurs rapides (RAC/T116, RAC/TUBE) sont strictement incompatibles avec les conducteurs rigides. Utilisez uniquement les boîtes coulées à la résine.</li>`;
    }

    /* ---- SCHÉMAS ---- */
    const schemaDisplayEl = document.getElementById('lc-schema-key-display');
    const schemaImgContainer = document.getElementById('lc-schema-image');
    schemaImgContainer.innerHTML = '';
    currentSchemaUrls = [];

    if (schemaDisplayEl) {
      schemaDisplayEl.hidden = true;
      schemaDisplayEl.textContent = '';
    }

    if (install_type === '100_lumihome' && lines_count === '2_lignes' && totalPower <= 48 && totalPower > 24) {
      renderSchema(`${baseSchemaKey}_96w`, schemaImgContainer, "Option A : 2 Lignes alimentées par 1 Transformateur 96W central");
      renderSchema(`${baseSchemaKey}_2_transfos`, schemaImgContainer, "Option B : 2 Lignes indépendantes avec 2 Transformateurs 24W");
    } else {
      renderSchema(baseSchemaKey, schemaImgContainer);
    }

    if (btnDownloadSchema) btnDownloadSchema.disabled = currentSchemaUrls.length === 0;

    /* ---- BUNDLE PANIER ---- */
    const bundleItems = computeBundleItems(state.answers, powerSetup);
    renderBundle(bundleItems);

    successContainer.classList.remove('lc-hidden');
  }

  function showError(msg) {
    const errContainer = document.getElementById('lc-error-state');
    errContainer.textContent = msg;
    errContainer.classList.remove('lc-hidden');
    if (btnDownloadSchema) btnDownloadSchema.disabled = true;
    currentSchemaUrls = [];
  }

  /* --------------------------------------------------------------
     CALCUL ET RENDU DU PACK PRODUITS (BUNDLE)
  -------------------------------------------------------------- */

  function computeBundleItems(answers, powerSetup) {
    const { install_type, spot_type, bulb_power, spots_count, lines_count, distance } = answers;
    const spotsNum = parseInt(spots_count, 10) || 0;
    const linesNum = lines_count === '2_lignes' ? 2 : 1;
    const items = [];

    // Spots & Ampoules
    if (spot_type === 'led_integree') {
      pushItem(items, 'spot_led', spotsNum);
    } else if (spot_type === 'ampoule') {
      pushItem(items, 'spot_ampoule', spotsNum);
      pushItem(items, 'ampoule', spotsNum);
    }

    // Transformateurs
    if (powerSetup.t96 > 0 && productsMap['transformer_96w']) {
      pushItem(items, 'transformer_96w', powerSetup.t96);
    } else if (powerSetup.t96 > 0 && !productsMap['transformer_96w']) {
      // Fallback si la fiche produit 96W n'est pas encore liée
      const equivalent24W = Math.ceil((powerSetup.t96 * 96) / 24);
      pushItem(items, 'transformer_24w', equivalent24W);
    }

    if (powerSetup.t24 > 0) {
      pushItem(items, 'transformer_24w', powerSetup.t24);
    }

    // Accessoires d'installation
    if (install_type === '100_lumihome') {
      const rallongesCount = spotsNum + 1;
      pushItem(items, 'rallonge_25m', rallongesCount);
    } else if (install_type === 'cable_rigide') {
      const boitiersCount = spotsNum + 1;
      pushItem(items, 'boite_rac_box3_68', boitiersCount);
      pushItem(items, 'resine', boitiersCount);
    } else if (install_type === 'cable_souple') {
      const { connectors: connectorsCount, tubes: tubesCount } = connectorsForSouple(spotsNum, linesNum);
      if (connectorsCount > 0) {
        const connectorOptions = [];
        if (productsMap['connecteur_rac_t116']) {
          connectorOptions.push({ key: 'connecteur_rac_t116', product: productsMap['connecteur_rac_t116'] });
        }
        if (productsMap['boite_rac_box3_68']) {
          connectorOptions.push({ key: 'boite_rac_box3_68', product: productsMap['boite_rac_box3_68'] });
        }
        if (connectorOptions.length >= 1) {
          pushItem(items, connectorOptions[0].key, connectorsCount, connectorOptions.length > 1 ? connectorOptions : null);
        } else {
          pushItem(items, 'connecteur_rac_t116', connectorsCount);
        }
      }
      pushItem(items, 'connecteur_tube', tubesCount);
    }

    return items;
  }

  function pushItem(items, key, quantity, options) {
    if (!quantity || quantity < 1) return;
    const product = productsMap[key];
    const item = { key, quantity: Math.round(quantity), product: product || null };
    if (options && options.length > 1) {
      item.options = options;
    }
    items.push(item);
  }

  function renderBundle(items) {
    if (!bundleContainer || !bundleList) return;
    currentBundleItems = items;
    bundleList.innerHTML = '';

    let displayedCount = 0;
    const missingKeys = [];

    items.forEach((item, originalIndex) => {
      if (!item.product || !item.product.variant_id) {
        missingKeys.push(humanKey(item.key));
        return;
      }
      if (displayedCount > 0) {
        const plus = document.createElement('div');
        plus.className = 'lc-bundle-plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        bundleList.appendChild(plus);
      }
      bundleList.appendChild(buildBundleCard(item, originalIndex));
      displayedCount++;
    });

    if (displayedCount === 0) { bundleContainer.hidden = true; return; }

    const totalCents = items.reduce((sum, i) => {
      if (!i.product || !i.product.variant_id) return sum;
      return sum + (i.product.price * i.quantity);
    }, 0);
    bundleTotalEl.textContent = formatMoney(totalCents);

    if (missingKeys.length > 0 && bundleNote) {
      bundleNote.textContent = 'Note : Certains éléments (' + missingKeys.join(', ') + ') doivent être ajoutés dans l’éditeur Shopify pour figurer au pack.';
      bundleNote.hidden = false;
    } else if (bundleNote) {
      bundleNote.hidden = true;
    }

    resetAddAllButton();
    bundleContainer.hidden = false;
  }

  function buildBundleCard(item, itemIndex) {
    const card = document.createElement('div');
    card.className = 'lc-bundle-item';
    const lineTotal = item.product.price * item.quantity;
    const hasOptions = item.options && item.options.length > 1;

    let optionsHtml = '';
    if (hasOptions) {
      const opts = item.options.map(opt => {
        const selected = opt.key === item.key ? 'selected' : '';
        return `<option value="${escapeAttr(opt.key)}" ${selected}>${escapeHtml(opt.product.title)}</option>`;
      }).join('');
      optionsHtml = `
        <div class="lc-bundle-item-swap-wrapper">
          <label class="lc-bundle-item-swap-label">Variante :</label>
          <select class="lc-bundle-item-swap" data-item-index="${itemIndex}">
            ${opts}
          </select>
        </div>
      `;
    }

    card.innerHTML = `
      <a href="${escapeAttr(item.product.url || '#')}" target="_blank" rel="noopener" class="lc-bundle-item-link">
        <div class="lc-bundle-item-img">
          <img src="${escapeAttr(item.product.image || '')}" alt="${escapeAttr(item.product.title)}" loading="lazy">
          <span class="lc-bundle-item-qty">×${item.quantity}</span>
        </div>
        <p class="lc-bundle-item-title">${escapeHtml(item.product.title)}</p>
        <p class="lc-bundle-item-price">${formatMoney(lineTotal)}</p>
      </a>
      ${optionsHtml}
    `;
    return card;
  }

  function hideBundle() { if (bundleContainer) bundleContainer.hidden = true; }

  function resetAddAllButton() {
    if (!btnAddAll) return;
    btnAddAll.disabled = false;
    const label = btnAddAll.querySelector('.lc-btn-label');
    if (label) label.textContent = 'Ajouter tout au panier';
  }

  function handleAddAllToCart() {
    const items = (currentBundleItems || []).filter(i => i.product && i.product.variant_id && i.quantity > 0);
    if (items.length === 0) return;

    const label = btnAddAll.querySelector('.lc-btn-label');
    const originalText = label ? label.textContent : '';
    btnAddAll.disabled = true;
    if (label) label.textContent = 'Ajout en cours…';

    const payload = { items: items.map(i => ({ id: i.product.variant_id, quantity: i.quantity })) };

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(async r => {
        const body = await r.json().catch(() => ({}));
        if (!r.ok) throw body;
        return body;
      })
      .then(() => refreshAndOpenMiniCart())
      .then(() => {
        if (label) label.textContent = '✓ Ajouté au panier';
        setTimeout(resetAddAllButton, 2500);
      })
      .catch(err => {
        console.error('[Configurateur 12V] Add to cart error:', err);
        btnAddAll.disabled = false;
        if (label) label.textContent = originalText;
        const message = (err && err.description) || (err && err.message) || "Une erreur est survenue lors de l'ajout au panier. Merci de réessayer.";
        alert(message);
      });
  }

  function refreshAndOpenMiniCart() {
    const sectionUrl = `${window.location.pathname}?section_id=mini-cart`;
    return fetch(sectionUrl, { credentials: 'same-origin' })
      .then(r => r.ok ? r.text() : '')
      .then(html => {
        if (!html) return;
        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('#mini-cart') || doc.querySelector('cart-drawer');
          const existingDrawer = document.querySelector('#mini-cart') || document.querySelector('cart-drawer');
          if (newDrawer && existingDrawer) {
            existingDrawer.innerHTML = newDrawer.innerHTML;
          }
        } catch (e) { /* silencieux */ }
      })
      .catch(() => {})
      .then(() => openMiniCart());
  }

  function openMiniCart() {
    const drawer = document.querySelector('#mini-cart') || document.querySelector('cart-drawer');
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (e) { /* fallback */ }
    }
    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open', 'drawer--open');
    setTimeout(() => {
      const isOpen = drawer.hasAttribute('open') || drawer.classList.contains('is-open');
      if (isOpen) return;
      const opener = document.querySelector('[aria-controls="mini-cart"]:not([data-action="close"])');
      if (opener) opener.click();
    }, 60);
  }

  function handleDownloadSchema() {
    if (!currentSchemaUrls.length) return;
    btnDownloadSchema.disabled = true;
    const originalHtml = btnDownloadSchema.innerHTML;

    Promise.all(currentSchemaUrls.map((s, i) => downloadOne(s.url, buildFilename(s, i))))
      .catch(err => console.error('[Configurateur 12V] Download error:', err))
      .finally(() => {
        btnDownloadSchema.disabled = false;
        btnDownloadSchema.innerHTML = originalHtml;
      });
  }

  function downloadOne(url, filename) {
    return fetch(url, { mode: 'cors' })
      .then(r => { if (!r.ok) throw new Error('Fetch failed'); return r.blob(); })
      .then(blob => triggerBlobDownload(blob, filename))
      .catch(() => { window.open(url, '_blank', 'noopener'); });
  }

  function triggerBlobDownload(blob, filename) {
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
  }

  function buildFilename(schemaItem, index) {
    const base = (schemaItem.title || 'schema-cablage').toString().toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'schema';
    const ext = extractExt(schemaItem.url) || 'jpg';
    const suffix = currentSchemaUrls.length > 1 ? `-${index + 1}` : '';
    return `lumihome-${base}${suffix}.${ext}`;
  }

  function extractExt(url) {
    const m = String(url).match(/\.(jpe?g|png|webp|svg|pdf|gif)(?:\?|#|$)/i);
    return m ? m[1].toLowerCase() : null;
  }

  function formatMoney(cents) {
    const amount = (cents / 100);
    const formatted = amount.toFixed(2).replace('.', ',');
    if (moneyFormat && moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/g, formatted);
    }
    return formatted + ' €';
  }

  function safeParseJSON(text, fallback) {
    try { return JSON.parse(text); } catch (e) { return fallback; }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, ch => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' }[ch]));
  }

  function escapeAttr(s) { return escapeHtml(s).replace(/`/g, '&#96;'); }

  function humanKey(key) {
    return ({
      spot_led: 'Spot LED intégrée',
      spot_ampoule: 'Spot ampoule',
      ampoule: 'Ampoule',
      transformer_24w: 'Transformateur 24W',
      transformer_96w: 'Transformateur 96W',
      rallonge_25m: 'Rallonge 2,5m',
      boite_rac_box3_68: 'Boîte RAC-BOX3-68',
      connecteur_rac_t116: 'Connecteur RAC/T116',
      connecteur_tube: 'Connecteur tube',
      resine: 'Résine'
    })[key] || key;
  }
});